import ActionFilter from "./ActionFilter";
import AccountFilter from "./AccountFilter";
import DateRangeFilter from "./DateRangeFilter"
import { IGWidget } from "../libs/GWidget";
import SearchFilter, { useSearchFilter } from "./SearchFilter";
import { ITransactionFilter } from "../portlibs/PortUtils";
import useActionFilter from "../portlibs/ActionFilterProvider";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";

export interface IHistoryFilterProps extends IGWidget {
    hideAccount?:boolean
}

export function useHistoryFilter() : ITransactionFilter{
    const search = useSearchFilter()
    const {actions} = useActionFilter()
    const {start,end} = useDateRangeFilter()
    return {actions,search,start,end}
}

export default function HistoryFilter(props:IHistoryFilterProps) {
    return <>
        {!props.hideAccount && <AccountFilter/>}
        <SearchFilter/>
        <DateRangeFilter/>
        <ActionFilter/>
    </>
}
